import { useCallback } from 'react';
import { YouTubeProps } from 'react-youtube';

import { PlayerType } from '../../constants';
import type { InitPlayerFn } from '../../types';
import { getPlayerType } from '../../utils';
import PlayerAdapter from '../PlayerAdapter';

interface Input {
    url: string;
    togglePlayStatus: (isVideoPlaying: boolean) => void;
    initPlayer?: InitPlayerFn;
}

interface Output {
    playerType: PlayerType;
    onPlay: VoidFn;
    onReady: YouTubeProps['onReady'];
    onPause: VoidFn;
}

const useYouTubeEmbedVideo = ({
    url,
    initPlayer,
    togglePlayStatus,
}: Input): Output => {
    const playerType = getPlayerType(url);

    const onPlay = useCallback(() => {
        togglePlayStatus(true);
    }, [togglePlayStatus]);

    const onPause = useCallback(() => {
        togglePlayStatus(false);
    }, [togglePlayStatus]);

    const onReady = useCallback<NonNullable<YouTubeProps['onReady']>>(
        ({ target: player }) => {
            if (!initPlayer) return;

            initPlayer(
                new PlayerAdapter({
                    player,
                    type: PlayerType.YOUTUBE,
                })
            );
        },
        [initPlayer]
    );

    return {
        playerType,
        onPlay,
        onPause,
        onReady,
    };
};

export default useYouTubeEmbedVideo;
